import SurveyImage from '@hotjar/shared-assets/images/integrations/ms-teams/survey-response.png';
import FeedbackImage from '@hotjar/shared-assets/images/integrations/ms-teams/feedback-response.png';
import type { Integration } from '../types';

import * as MsTeamsFeature from '../domains/ms-teams/feature';

export const msTeams: Integration = {
  slug: 'microsoft-teams',
  icon: 'microsoft_teams',
  name: 'integrations:ms_teams.integrations-page.title',
  provider: 'integrations:card.hotjar',
  tokenName: null,
  otterName: 'teams_webhook',
  actionLabel: {
    enable: 'integrations:ms_teams.integrations-page.button-action.enable',
    disable: 'integrations:ms_teams.integrations-page.button-action.disable',
  },
  description: 'integrations:ms_teams.integrations-page.description',
  descriptionLarge: 'integrations:ms_teams.integrations-page.description-large',
  resources: [
    {
      copy: 'integrations:ms_teams.integrations-page.key-benefits',
      url: 'https://www.hotjar.com/integrations/microsoft-teams/',
      icon: 'page_full',
    },
    {
      copy: 'integrations:ms_teams.integrations-page.using-with-hotjar',
      url: '/articles/10211927123223',
      icon: 'page_full',
    },
  ],
  images: [SurveyImage, FeedbackImage],
  videoUrl: 'https://www.youtube.com/embed/oip9xK6ZBa4',
  askGate: MsTeamsFeature.GATE_FEEDBACK,
  isEnabled: false,
  settings: null,
  isBeta: MsTeamsFeature.FEATURE_IS_BETA,
};
